"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userDetailsSchema = exports.linkPolicySchema = exports.AssociatePolicySchema = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _Validations = require("../../Validations");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// for everything

var userDetailsSchema = exports.userDetailsSchema = yup.object().shape({
  firstName: yup.string().required('First name is required field').test('first-name-length', _Validations.validationErrorMsgs.shortNameRegex, function (value) {
    return _Validations.validationRegex.shortNameRegex.test(value);
  }),
  lastName: yup.string().required('Last name is required field').test('last-name-length', _Validations.validationErrorMsgs.nameRegex, function (value) {
    return _Validations.validationRegex.nameRegex.test(value);
  }),
  dateOfBirth: yup.string().required('Date of birth is a required field').test('dateFormat', 'Date is Invalid. Please review and try again', function (value) {
    return (0, _moment.default)(value, 'YYYY-MM-DD', true).isValid();
  }).test('maxDate', 'The date of birth cannot be a future date.', function (value) {
    var maxDate = (0, _moment.default)();
    var inputDate = (0, _moment.default)(value);
    if (inputDate.isAfter(maxDate)) {
      return false;
    } else {
      return true;
    }
  }).test('minDate', 'The date of birth cannot be before 01/01/1910.', function (value) {
    var minDate = (0, _moment.default)('1910-01-01');
    var inputDate = (0, _moment.default)(value);
    if (inputDate.isBefore(minDate)) {
      return false;
    } else {
      return true;
    }
  }),
  email: yup.string().required('Email Address is required field').email('Invalid email address format').max(75),
  phone: yup.string().required('Telephone number is required field').test('telephone', _Validations.validationErrorMsgs.phoneRegex, function (value) {
    return _Validations.validationRegex.phoneRegex.test(value);
  }),
  customerOrBillingNumber: yup.string().required('Customer or billing number is required field').test('customerOrBilling-digit', _Validations.validationErrorMsgs.customerOrBillingNumberPattern, function (value) {
    return _Validations.validationRegex.customerOrBillingNumberPattern.test(value);
  }),
  password: yup.string().required('Password is required field').min(8, 'Use at least 8 character').test('password-digit', _Validations.passwordErrorMsgs.digitRegex, function (value) {
    return _Validations.passwordRegex.digitRegex.test(value);
  }).test('password-symbol', _Validations.passwordErrorMsgs.symbolRegex, function (value) {
    return _Validations.passwordRegex.symbolRegex.test(value);
  }).test('password-character', _Validations.passwordErrorMsgs.characterRegex, function (value) {
    return _Validations.passwordRegex.characterRegex.test(value);
  }).test('password-whitespace', _Validations.passwordErrorMsgs.whiteSpaces, function (value) {
    return !_Validations.passwordRegex.whiteSpaces.test(value);
  }),
  agreeToTerms: yup.boolean().test('accepted-terms-of-use', 'Please accept the terms of use.', function (value) {
    return value;
  })
});
var linkPolicySchema = exports.linkPolicySchema = yup.object().shape({
  policyNumber: yup.string().required('Policy number is required field')
  /* policyNumber: yup
    .string()
    .required('Policy number is required field')
    .length(7, validationErrorMsgs.policyPattern)
    .test('policy-digit', validationErrorMsgs.policyPattern, function(value) {
      return validationRegex.policyPattern.test(value);
    }), */
});
var AssociatePolicySchema = exports.AssociatePolicySchema = yup.object().shape({
  policyNumber: yup.string().required('*Field is required.')
  /* policyNumber: yup
    .string()
    .required('*Field is required.')
    .test('policy-digit', validationErrorMsgs.policyPattern, function(value) {
      return validationRegex.policyPattern.test(value);
    }), */
});